export default __webpack_public_path__ + "static/media/bike1.9896ad30.png";